import './component.scss';

export class CatalogSection {

    constructor(id, params = {}, result = {}, options = {}) {
        if (!id) {
            return
        }

        this.id = id
        this.params = params
        this.result = result
        this.options = options
        this.$component = document.getElementById(this.id)

        this.init()
    }

    init() {
        this.initObservers()
    }

    initObservers() {
        let self = this

        if (true === this.options.useSorter) {
            BX.addCustomEvent('sp.catalog.sorter.change', data => {
                this.csRefresh({data})
            })
        }

        BX.addCustomEvent('sp.catalog.smart.filter.loadproducts', data => {
            this.csRefresh({data})
        })

        this.$component.on('click', '.js-item-switch', function () {
            self.switch(this)
        })

        BX.addCustomEvent('onCatalogSectionChangeOffer', eventData => {
            this.changeInfo(eventData.product, eventData.offer, eventData.switch)
        })
    }

    async csRefresh(params = {}) {
        let resultData = null,
            url = Gourji.Api.getCurPageParams(),
            postData = {
                AJAX_CALL_ID: this.id,
            }

        if (params?.postData) {
            postData = Object.assign({}, postData, params.postData)
        }

        this.csShowPreloader()

        resultData = await Gourji.Api.query(url, postData)

        this.csHidePreloader()

        history.pushState(null, null, url)

        Gourji.Replacer.replaceElements(this.$component, resultData?.HTML?.elements)
        Gourji.Replacer.replaceNav(this.$component, resultData?.HTML?.nav)

        BX.onCustomEvent('sp.catalog.sections.productsreload')
    }

    switch($switch) {
        if (!this.result.ITEMS) {
            return
        }

        let finedProduct = null,
            finedSwitch = null,
            index = 0

        for (let product of this.result.ITEMS) {
            if (!product.CUSTOM_COLOR_SWITCH) {
                continue
            }

            for (let switchData of Object.values(product.CUSTOM_COLOR_SWITCH)) {
                if (switchData.ID !== $switch.dataset.id) {
                    continue
                }

                finedProduct = product
                finedSwitch = switchData

                break
            }

            index++

            if (null !== finedProduct) {
                break
            }
        }

        if (null === finedProduct || null === finedSwitch) {
            return
        }

        let eventData = {
            product: finedProduct,
            offer: finedSwitch.OFFER,
            switch: finedSwitch,
        }
        BX.onCustomEvent('onCatalogSectionChangeOffer', [eventData]);
    }

    changeInfo(element, offer, switchData) {
        this.changeSwitch(element, offer, switchData)
        this.changePicture(element, offer, switchData)
        this.changePrice(element, offer, switchData)
        this.changeUrl(element, offer, switchData)
    }

    changeSwitch(element, offer, switchData) {
        let $product = document.querySelector(`.js-item-id-${element.ID}`),
            $switches = $product.querySelector('.js-item-switches'),
            $switch = $switches.querySelector(`.js-item-switch[data-id="${switchData.ID}"]`)

        if (0 < $switches.querySelectorAll('.js-item-switch.is-active').length) {
            $switches.querySelector('.js-item-switch.is-active').classList.remove('is-active')
        }

        $switch.classList.add('is-active')
    }

    changePicture(element, offer, switchData) {
        if (0 >= switchData?.PICTURES.length) {
            return
        }

        let $product = document.querySelector(`.js-item-id-${element.ID}`),
            $image = $product.querySelector('.js-item-image')

        $image.setAttribute('src', switchData?.PICTURES[0].SAFE_SRC)
    }

    changePrice(element, offer, switchData) {
        let $product = document.querySelector(`.js-item-id-${element.ID}`),
            $priceHtml = $product.querySelector(`.js-item-priceHtml`),
            $price = $product.querySelector(`.js-item-price-new`),
            $priceOld = $product.querySelector(`.js-item-price-old`),
            html = ''

        if ('Y' === this.params.SHOW_OLD_PRICE && offer?.MIN_PRICE && 0 < offer?.MIN_PRICE?.DISCOUNT) {
            html += '<div class="product-item__old_price has-value">'
            html += `<s class="js-item-price-old">${offer.MIN_PRICE.PRINT_BASE_PRICE}</s>`
            html += '</div>'
        }

        html += `<div class="product-item__new_price js-item-price-new">${offer.MIN_PRICE.PRINT_PRICE}</div>`

        $priceHtml.innerHTML = html
    }

    changeUrl(element, offer, switchData) {
        let $product = document.querySelector(`.js-item-id-${element.ID}`),
            originalUrl = $product.dataset.url,
            $links = $product.querySelectorAll('a')

        if (0 < $links.length) {
            for (let $link of $links) {
                $link.setAttribute('href', `${originalUrl}?offer=${offer.ID}`)
            }
        }
    }

    csShowPreloader() {
        BX.showWait(BX(this.id))
    }

    csHidePreloader() {
        BX.closeWait(BX(this.id))
    }

}
